import { render, staticRenderFns } from "./SupportContacts.vue?vue&type=template&id=38d11723"
import script from "./SupportContacts.vue?vue&type=script&lang=ts"
export * from "./SupportContacts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseIcon: require('/builds/medtochka/medtochka-frontend/core/components/Base/BaseIcon.vue').default})
